import KeyMetric from '@/pages/CompanyReport/components/Overview/components/DeprecatedHeader/components/KeyMetric';
import PencilOutline from '@simplywallst/ui-core/icons/PencilOutline';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';

import { toCurrencyTruncated } from '@/utilities/formatting';
import type { CurrencyISO } from '@/constants/currencies';

type Props = {
  currencyISO: CurrencyISO | null;
  fairValue: number | null;
  npvPerShare: number | null;
  onClick: () => void;
  lastSharePrice: number | null;
};

export const PopulatedState = ({
  currencyISO,
  fairValue,
  npvPerShare,
  onClick,
  lastSharePrice,
}: Props) => {
  const formattedFairValue = toCurrencyTruncated(
    fairValue || 0,
    2,
    currencyISO ?? 'XXX'
  );

  return (
    <div
      className="group/narrative-key-metric cursor-pointer"
      onClick={onClick}
    >
      <KeyMetric
        type="Metric"
        testId="my-fair-value"
        title={
          <span className="grid grid-cols-[max-content_max-content] items-start gap-1">
            <span>My Fair Value</span>
            <PencilOutline className="size-x2 fill-soft group-hover/narrative-key-metric:fill-solid" />
          </span>
        }
        metric={
          <div className="grid grid-cols-[max-content_auto] items-center gap-2">
            <span className="m-0 text-xs text-solid">{formattedFairValue}</span>
            <div className="text-tiny">
              <CompanyIntrinsicDiscount
                fairValue={fairValue}
                lastSharePrice={lastSharePrice}
                npvPerShare={npvPerShare}
              />
            </div>
          </div>
        }
      />
    </div>
  );
};
